export const downloadAsXml = (name: string, file: string) => {
  const fileName = name + '.xml';
  const fileBlob = new Blob([file], { type: 'application/xml' });
  const fileUrl  = window.URL.createObjectURL(fileBlob);

  handleDownload(fileName, fileUrl);
}

const handleDownload = (fileName: string, fileUrl: any) => {
  const tempUrl = fileUrl;
  const a = window.document.createElement('a');

  a.setAttribute("type", "hidden");
  a.href = tempUrl;
  a.download = fileName;

  window.document.body.appendChild(a);

  a.click();

  window.document.body.removeChild(a);
  window.URL.revokeObjectURL(tempUrl);
}
